import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flashlight-line text-base text-white"></i>
              </div>
              <span className="text-base font-bold text-foreground-900 font-heading">网页版免费91</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              无需下载安装，直接在浏览器中免费使用的在线平台。支持多设备访问，随时随地畅享便捷服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">热门分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">关于我们</Link></li>
              <li><a href="#features" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">平台功能</a></li>
              <li><a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">联系方式</h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@mianfei91.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-customer-service-2-line text-primary-500"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500"></i>
                <span>中国 · 北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 网页版免费91. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            本站所有工具均免费使用 · 无需下载 · 安全可靠
          </p>
        </div>
      </div>
    </footer>
  );
}